import { createContext } from 'react';
export const defaultModalTransitionContext = {
  transitioning: false
};
export const ModalTransitionContext = /*#__PURE__*/createContext(defaultModalTransitionContext);
export const {
  Consumer: ModalTransitionContextConsumer,
  Provider: ModalTransitionContextProvider
} = ModalTransitionContext;